// import { toStr } from '@enonic/js-utils/value/toStr';
import type {ComponentProps, PartData} from '@enonic/react-components';
import React from 'react';
import Header, {type HeaderProps} from '../components/software-show/Header/Header';
import Metadata, {type MetadataProps} from '../components/software-show/Metadata/Metadata';
import Changelog, {type ChangelogProps} from '../components/software-show/Changelog/Changelog';
import Enonicarousel, {type EnonicarouselProps} from '../components/Enonicarousel';
import StarterSetup, {type StarterSetupProps} from '../components/software-show/StarterSetup/StarterSetup';


interface SoftwareShowProps
	extends Record<string, unknown> {
	selectedVersion: HeaderProps['selectedVersion']
	header: HeaderProps['header']
	metadata: MetadataProps['metadata']
	carousel: EnonicarouselProps
	details?: string
	changelog: ChangelogProps['changelog']
	downloadInstructions?: HeaderProps['downloadInstructions']
	starterSetup?: StarterSetupProps
}


export function SoftwareShow({
	data
}: ComponentProps<PartData>) {
	// console.debug('SoftwareShow', toStr({ selectedVersion, header, metadata, carousel, details, changelog, downloadInstructions }));

	const {
		selectedVersion,
		header,
		metadata,
		carousel,
		details,
		changelog,
		downloadInstructions,
		starterSetup,
	} = data as SoftwareShowProps;
	const hasMedia = carousel.screenshots.length > 0 || Boolean(carousel.video?.id);

	return (
		<article className="software-show">
			<Header {...{ header, selectedVersion, downloadInstructions }} />
			<Metadata metadata={metadata} />
			<div className="software-show__body">
				{!starterSetup && <Enonicarousel {...carousel} />}
				<section className="software-show__description">
					{ details && <div dangerouslySetInnerHTML={{ __html: details }} /> }
				</section>
				{starterSetup && <StarterSetup {...starterSetup} />}
				{starterSetup && hasMedia && (
					<section className="software-show__starter-media">
						<h2>Media</h2>
						<Enonicarousel {...carousel} />
					</section>
				)}
				{changelog.versions.length > 0 && <Changelog changelog={changelog} />}
			</div>
		</article>
	);
}
